module.exports = __webpack_public_path__ + "static/media/maracaibo.2081b2e3.JPG";